import type { Responsive } from '#types/common'
/**
 * Calculates responsive values for aspect ratio
 * @param size - An object containing responsive values for width and height
 * @param size.height - Responsive height value
 * @param size.width - Responsive width value
 * @returns A responsive object containing a calculated aspect ratio per breakpoint
 * @category Utils
 */
export const getResponsiveAspectRatio = (
  size: { height: Responsive<number>, width: Responsive<number> }
): Responsive<number> => {
  const aspectRatio: Responsive<number> = {
    sm: size.width.sm / size.height.sm
  }

  if (size.width.md && size.height.md) {
    aspectRatio.md = size.width.md / size.height.md
  }

  if (size.width.lg && size.height.lg) {
    aspectRatio.lg = size.width.lg / size.height.lg
  }

  return aspectRatio
}
